// Brokers
export const BROKERS_FETCHED = 'BROKERS_FETCHED';
export function brokersFetched(top10BrokersReport) {
  return {
    type: BROKERS_FETCHED,
    top10BrokersReport: top10BrokersReport,
  };
}
export const BROKERS_REQUEST_STARTED = 'BROKERS_REQUEST_STARTED';
export function brokersRequestStarted() {
  return {
    type: BROKERS_REQUEST_STARTED,
    isFetching: true,
  };
}

export const BROKERS_REQUEST_ERROR = 'BROKERS_REQUEST_ERROR';
export function brokersRequestError() {
  return {
    type: BROKERS_REQUEST_ERROR,
  };
}
